<script lang="ts">
	
	let className = '';
	export { className as class };
</script>

<div class="flex flex-row navigation-bar {className}">
    <slot/>
</div>

<style>
	.navigation-bar {
		display: flex;
		padding: 16px;
		align-items: center;
		gap: 8px;

		border-radius: 10px;
		border: 1px solid var(--popup-border, #2d2d2d);
		background: var(
			--gray-20070,
			linear-gradient(135deg, rgba(57, 57, 57, 0.7) 0%, rgba(40, 40, 40, 0.7) 100%)
		);
	}
</style>